
import React from "react";
import { cn } from "@/lib/utils";

interface CarouselDotsProps {
  total: number;
  activeIndex: number;
  onDotClick?: (index: number) => void;
  className?: string;
}

export function CarouselDots({ 
  total, 
  activeIndex, 
  onDotClick,
  className 
}: CarouselDotsProps) {
  if (total <= 1) return null;
  
  return (
    <div className={cn("flex justify-center gap-2 mt-2 pb-1", className)}>
      {Array.from({ length: total }).map((_, index) => (
        <button
          key={index}
          type="button"
          onClick={() => {
            console.log(`Dot clicked: ${index}`);
            onDotClick?.(index);
          }}
          className={cn(
            "w-2.5 h-2.5 rounded-full transition-all duration-300",
            activeIndex === index 
              ? "bg-primary scale-110" 
              : "bg-gray-300 hover:bg-gray-400"
          )}
          aria-label={`Go to slide ${index + 1}`}
          aria-current={activeIndex === index ? "true" : "false"}
        />
      ))}
    </div>
  );
}
